import mark from './logo_routex.png'

/**
 * A marca do RouteX.
 *
 * É só o símbolo — não há wordmark no arquivo, então o nome do produto continua sendo texto ao
 * lado dele. As cores medidas do PNG (#fa8c0a–#faaa0a) caem na faixa do acento da paleta
 * (`RoutexTokens.gold`, #f59e0b), então o símbolo combina com o tema sem ajuste.
 */
export const logo = {
  /** Símbolo em âmbar sobre fundo transparente. */
  mark,
} as const
